import { CreateCurrencyDto } from '../../types/currency.types';
import { PaginationInputDto } from '../../model/common/PaginatedInputDto';
import { get, post, del } from '../../utils/BaseService';

export async function getAllCurrencies(dispatch: any, props: PaginationInputDto) {
  return await post(dispatch, '/currency/getAllCurrencies', props);
}

export async function getActiveCurrencies(dispatch: any) {
  return await get(dispatch, '/currency/getActiveCurrencies', null);
}

export async function getCurrencyById(dispatch: any, id: string) {
  return await get(dispatch, `/currency/getCurrencyById/${id}`, null);
}

export async function createCurrency(dispatch: any, props: CreateCurrencyDto) {
  return await post(dispatch, '/currency/createCurrency', props);
}

export async function updateCurrency(dispatch: any, id: string, props: CreateCurrencyDto) {
  return await post(dispatch, `/currency/updateCurrency/${id}`, props);
}

export async function deleteCurrency(dispatch: any, id: string) {
  return await del(dispatch, `/currency/deleteCurrency/${id}`, parseInt(id));
}